<template>
  <el-row class="editor" v-loading="loading">
    <div class="content-user hidden-sm-and-down">
      <UserAvatar v-if="type === 'comment'" :size="40" :user="user" />
      <UserAvatar v-else :size="120" :user="user" />

      <div class="user-ext">
        {{ user && user.nickname ? user.nickname : null }}
      </div>
    </div>
    <el-col
      :xs="24"
      :sm="24"
      :md="20"
      :lg="20"
      :xl="20"
      class="content-value"
      id="reply-content"
    >
      <div
        v-if="user && Object.keys(user).length > 0"
        class="content-value-html"
        id="editor-card"
      >
        <el-form :model="form" ref="form" :rules="rules">
          <el-form-item label="标题" prop="title" v-if="type == 'topic'">
            <el-input v-model="form.title" style="width: 80%"></el-input>
          </el-form-item>

          <el-form-item label="类型" prop="postType" v-if="type == 'topic'">
            <el-select
              v-model="form.postType"
              placeholder="请选择"
              style="width: 160px"
              @change="getPostType()"
            >
              <el-option key="question" label="技术问答" value="question">
              </el-option>
              <el-option key="file" label="寻找文件" value="file"> </el-option>
              <el-option key="post" label="交流" value="post"> </el-option>
            </el-select>
            <span class="input-help hidden-xs-only">
              问题反馈请选择技术问答,寻找驱动和例程选择寻找文件
            </span>
          </el-form-item>

          <el-form-item label="邮箱" prop="email" v-if="emailRequired">
            <el-input v-model="form.email" style="width: 160px"></el-input>
            <span class="input-help hidden-xs-only">
              技术问答或寻找文件需要填写邮箱 ,方便技术人员及时解答和回访
            </span>
          </el-form-item>

          <el-form-item label="产品" v-if="type == 'topic'" filterable>
            <el-select
              v-model="form.tags"
              placeholder="请选择"
              style="width: 320px"
              multiple
              filterable
            >
              <el-option
                v-for="item in products"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
            <span class="input-help hidden-xs-only">
              选择具体的产品,有助于更好的分配工程师解答,可多选
            </span>
          </el-form-item>

          <div :style="border">
            <Toolbar
              v-if="type === 'comment'"
              style="border-bottom: 1px solid #ccc"
              :editor="editor"
              :defaultConfig="commentToolbarConfig"
              :mode="mode"
            />
            <Toolbar
              v-else
              style="border-bottom: 1px solid #ccc"
              :editor="editor"
              :defaultConfig="toolbarConfig"
              :mode="mode"
            />

            <Editor
              :style="{
                height: `${height}px`,
                // overflowY: 'hidden',
                textAlign: 'left',
              }"
              v-model="form.html"
              :defaultConfig="editorConfig"
              :mode="mode"
              height="300px"
              @onCreated="onCreated"
              @onChange="onChange"
              @onFocus="onFocus"
            />
          </div>
        </el-form>

        <div v-if="errorMessage" class="error">
          {{ errorMessage }}
        </div>
        <el-button type="primary" class="reply-btn" @click="handleSubmit">{{
          this.btn
        }}</el-button>
      </div>

      <div v-else>
        <div class="login-warn">
          <div class="login-tip">
            您尚未登录，登录后可以

            <ul>
              <li>轻松连接技术专家</li>
              <li>享受与各地专业人士互动的乐趣</li>
            </ul>
          </div>
          <div class="login">
            <router-link to="/login">
              <el-button type="primary" class="login-btn"
                >登录</el-button
              ></router-link
            >
          </div>
        </div>
      </div>
      <div
        class="reminder-box"
        v-if="user && Object.keys(user).length > 0 && type != 'comment'"
      >
        <ul>
          <li>
            为维护良好社区环境，保障每位用户的优质体验，请您严格遵守
            <router-link class="highlight" to="/term.html"
              >社区规则</router-link
            >
            。
          </li>
          <li>
            留下
            <span class="highlight">邮箱地址</span>
            ，方便工程师快速与您取得联系或发送您需要的文件，精准解决您的问题
          </li>
          <li>
            社区现已全面支持 <span class="highlight">代码高亮</span> 功能，
            正确规范的格式能够极大提升代码可读性，让他人更轻松地理解您分享的内容，
            期待您的分享更加清晰有序 。
          </li>
          <li>
            您的每一条意见和反馈对社区建设都至关重要，若您有关于社区建设的宝贵想法或建议，
            欢迎随时联系我们，邮箱地址为：<span class="highlight"
              >community@wch.cn</span
            >
          </li>
        </ul>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import {
  saveReply,
  updateReply,
  saveTopic,
  updateTopic,
  updateUserTopic,
  getPost,
  getProducts,
} from "@/service/post";
import { uploadImg } from "@/service/upload";
import UserAvatar from "@/components/UserAvatar";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { DomEditor } from "@wangeditor/editor";
import { mapGetters } from "vuex";
export default {
  props: {
    values: {
      required: true,
    },
    height: {
      default: "500",
    },
    type: {
      default: "reply",
    },

    btn: {
      default: "发帖",
    },
  },

  data() {
    return {
      loading: false,
      emailRequired: false,
      products: [],
      form: {
        html: "",
        title: "",
        postType: "",
        tags: [],
        email: "",
      },
      rules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          {
            min: 6,
            max: 50,
            message: "长度在 6 到 50 个字符",
            trigger: "blur",
          },
        ],
        postType: [{ required: true, message: "请选择类型", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
      },
      border: "border: 1px solid #ccc",
      errorMessage: "",
      editor: null,

      toolbarConfig: {
        toolbarKeys: [
          "bold",
          "underline",
          "italic",
          "clearStyle",
          // 分割线
          "|",
          // "bulletedList",
          //  "numberedList",
          "insertLink",
          "uploadImage",

          "emotion",
          "codeBlock",
          "|",
          "undo",
          "redo",
          "|",
          "fullScreen",
        ],
      },

      commentToolbarConfig: {
        toolbarKeys: ["insertLink", "uploadImage", "emotion"],
      },
      hideEditorConfig: {
        placeholder: "您需要登录后才可以回帖",
        readOnly: true,
      },
      editorConfig: {
        //autoFocus:false,
        placeholder:
          " 请勿发布广告和违法内容, 留下联系方式,以便更好更快服务您 --",
        codeDefaultLang: "c",
        MENU_CONF: {
          uploadImage: {
            // 自定义上传
            async customUpload(file, insertFn) {
              console.info(file);
              let formData = new FormData();
              formData.append("file", file);
              uploadImg(formData).then((res) => {
                const { code, data, message } = res;
                if (code === 0) {
                  const { url } = data;
                  const IMG_URL = process.env.VUE_APP_IMG_API;
                  console.info(IMG_URL);
                  insertFn(IMG_URL + "/uploads/image/" + url, "", "");
                } else {
                  this.$message.error(message);
                }
              });
            },
          },
          codeSelectLang: {
            codeLangs: [
              { text: "C", value: "c" },
              { text: "JAVA", value: "java" },
              { text: "PYTHON", value: "python" },
              { text: "C#", value: "csharp" },
              { text: "C++", value: "cpp" },
            ],
          },
        },
      },
      mode: "default", // or 'simple'
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
  components: {
    UserAvatar,
    Editor,
    Toolbar,
  },
  created() {
    this.url = process.env.VUE_APP_IMG_API;
    this.form.html = this.values.content;
    this.form.title = this.values.title;
    this.form.postType = this.values.postType;
    this.form.email = this.values.email;

    this.emailRequired =
      this.values.postType &&
      (this.values.postType == "question" || this.values.postType == "file")
        ? true
        : false;

    getProducts().then((res) => {
      if (res.code === 0) {
        this.products = res.data;
      }
    });

    //初始化产品选择

    if (this.values.tags && Object.keys(this.values.tags).length > 0) {
      this.form.tags = this.values.tags;
    }
  },

  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    getPostType() {
      //alert(this.form.postType);

      if (this.form.postType == "question" || this.form.postType == "file") {
        this.emailRequired = true;
      } else {
        this.emailRequired = false;
      }
    },
    onFocus() {
      const toolbar = DomEditor.getToolbar(this.editor);
      const c = this.editor.getConfig();
      const t = this.Toolbar;
      // console.info(c);
      const curTooleBarConfig = toolbar.getConfig();
      //console.info(curTooleBarConfig);

      // let text = this.getText(this.form.html);
      // if (this.isNull(text)) {
      //   const target = document.getElementById("editor-card");
      //   if (target) {
      //     target.scrollIntoView({ behavior: "smooth" }); // 使用平滑滚动
      //   }
      // }
    },
    handleSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let text = this.getText(this.form.html);

          if (!this.isNull(text)) {
            this.$confirm("确认提交了吗?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.handleSavePost();
              })
              .catch((e) => {
                console.log(e);
                this.$message({
                  type: "info",
                  message: "已取消提交",
                });
              });
          } else {
            this.errorMessage = "内容不能为空！";
            this.border = "border: 1px solid #F56C6C";
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    handleSavePost() {
      this.loading = true;
      const path = this.$route.path;
      //回复帖子

      const threadRegex = /thread-\d+-\d+\.html/;
      if (threadRegex.test(path)) {
        const id = this.$route.params.id ? this.$route.params.id : -1;
        saveReply({
          replyId: id,
          content: this.form.html,
        })
          .then((response) => {
            const { code, data, message } = response;
            this.loading = false;
            if (code == 0) {
              this.html = null;
              this.$message.success(message);
              this.$router.replace(`/thread-${id}-${data}.html?template=reply`);
              this.$router.replace(`/thread-${id}-${data}.html`);
              this.form.html = "";
            } else {
              this.$message.error(message);
            }
          })
          .catch((error) => {
            this.loading = false;
            console.error(error);
          });
      }
      const commentRegex = /^\/article\/[0-9]+\/[0-9]+\.html$/;
      if (commentRegex.test(path)) {
        const id = this.$route.params.id ? this.$route.params.id : -1;
        saveReply({
          replyId: id,
          content: this.form.html,
        })
          .then((response) => {
            const { code, data, message } = response;
            this.loading = false;
            if (code == 0) {
              this.html = null;
              this.$message.success("评论成功");

              this.form.html = "";
              this.$router.replace(
                `/article/${this.user.id}/${id}.html?template=comment`
              );
              this.$router.replace(`/article/${this.user.id}/${id}.html`);
            } else {
              this.$message.error(message);
            }
          })
          .catch((error) => {
            this.loading = false;
            console.error(error);
          });
      }

      if (path == "/reply_edit") {
        console.info(this.$route);
        const id = this.$route.query.id ? this.$route.query.id : -1;
        //编辑帖子
        updateReply({
          content: this.form.html,
          id: id,
        })
          .then((response) => {
            const { code, data, message } = response;
            this.loading = false;
            if (code == 0) {
              this.html = null;
              this.$message.success(message);
              const currentPage = this.$route.query.current_page
                ? this.$route.query.current_page
                : 1;
              this.$router.push(`/thread-${data}-` + currentPage + `.html`);
            } else {
              this.$message.error(message);
            }
          })
          .catch((error) => {
            this.loading = false;
            console.error(error);
          });
      }

      //createTopic

      if (path == "/topic_create") {
        const id = this.$route.query.forum_id ? this.$route.query.forum_id : -1;
        saveTopic({
          title: this.form.title,
          content: this.form.html,
          forumId: id,
          postType: this.form.postType,
          email: this.form.email,
          tags: this.form.tags,
        })
          .then((response) => {
            const { code, data, message } = response;
            this.loading = false;
            if (code == 0) {
              this.html = null;
              this.$message.success(message);
              this.$router.push(`/thread-${data}-1.html`);
            } else {
              this.$message.error(message);
            }
          })
          .catch((error) => {
            this.loading = false;
            console.error(error);
          });
      }

      if (path == "/topic_edit") {
        const id = this.$route.query.id ? this.$route.query.id : -1;

        updateTopic({
          title: this.form.title,
          content: this.form.html,
          postType: this.form.postType,
          email: this.form.email,
          tags: this.form.tags,
          id: id,
        })
          .then((response) => {
            const { code, data, message } = response;
            this.loading = false;
            if (code == 0) {
              this.html = null;
              this.$message.success(message);
              this.$router.push(`/thread-${data}-1.html`);
            } else {
              this.$message.error(message);
            }
          })
          .catch((error) => {
            this.loading = false;
            console.error(error);
          });
      }
      if (path == "/topic_update") {
        const id = this.$route.query.id ? this.$route.query.id : -1;

        updateUserTopic({
          title: this.form.title,
          content: this.form.html,
          postType: this.form.postType,
          email: this.form.email,
          tags: this.form.tags,
          id: id,
        })
          .then((response) => {
            const { code, data, message } = response;
            this.loading = false;
            if (code == 0) {
              this.html = null;
              this.$message.success(message);
              this.$router.push(`/thread-${data}-1.html`);
            } else {
              this.$message.error(message);
            }
          })
          .catch((error) => {
            this.loading = false;
            console.error(error);
          });
      }
    },
    onChange() {
      // console.info(this.form.html);
      let text = this.getText(this.form.html);

      if (!this.isNull(text)) {
        this.errorMessage = "";
        this.border = "border: 1px solid #ccc";
      }
    },
    // 判断富文本编辑器输入是否为空或回车
    getText(str) {
      return str
        .replace(/<[^<p>]+>/g, "") // 将所有<p>标签 replace ''
        .replace(/<[</p>$]+>/g, "") // 将所有</p>标签 replace ''
        .replace(/&nbsp;/gi, "") // 将所有 空格 replace ''
        .replace(/<[^<br/>]+>/g, ""); // 将所有 换行符 replace ''
    },
    isNull(str) {
      if (str == "") {
        return true;
      }
      let regu = "^[ ]+$";
      let re = new RegExp(regu);
      return re.test(str);
    },
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less">
// .topic-card {
//   .el-card__body {
//     padding: 3px;
//   }

//   .content {
//     text-align: left;
//     background-color: #ebebeb;
//     .topic {
//       display: flex;
//       .content-user {
//         width: 200px;
//         border-right: 2px solid #fff;
//         text-align: center;
//         padding-top: 20px;
//         .user-ext {
//           margin-top: 10px;
//           color: #1483dc;
//           font-weight: 700;
//         }
//       }
//       .content-value {
//         text-align: left;
//         width: 80%;
//         .content-value-html {
//           margin: 20px;
//           .topic-btn {
//             margin-top: 10px;
//           }
//         }
//       }
//     }
//   }
// }
.login-warn {
  // background-color: #fff;
  padding: 20px;

  ul {
    list-style: disc;
    li::marker {
      color: #00428d; /* 仅更改列表项标记的颜色 */
      font-size: 1.2em; /* 还可以调整大小等其他属性 */
    }
  }
  .login-btn {
    background-color: #00428d !important;
    margin-top: 10px;
  }
}

.reminder-box {
  background-color: #fff; /* 白色背景 */
  padding: 20px;
  border-radius: 8px;

  text-align: left; /* 文字左对齐 */
  border: 2px dashed #ccc; /* 低调的灰色虚线边框颜色 */

  margin: 20px;
}
.reminder-box h2 {
  margin-top: 0;
  color: #333;
  font-size: 18px;
  font-weight: bold;
}
.reminder-box ul {
  list-style-type: none;
  padding-left: 0;
  padding: 0;
  margin: 0;
}
.reminder-box li {
  margin-bottom: 15px;
  color: #333;
  font-size: 16px;
}
.highlight {
  color: #007bff; /* 高亮字体颜色 */
  font-weight: bold;
  font-size: 16px !important;
}
.input-help {
  margin-left: 5px;
  color: #666;
}
.editor {
  margin-top: 10px;

  border-radius: 4px;
  border: 1px solid #ebeef5;
  margin: 3px;
  background-color: #ebebeb;

  // overflow: hidden;
  color: #303133;
  transition: 0.3s;

  display: flex;

  .content-user {
    width: 200px;
    border-right: 2px solid #fff;
    text-align: center;
    padding-top: 20px;
    .user-ext {
      margin-top: 10px;
      color: #1483dc;
      font-weight: 700;
    }
    .content-user-data {
      width: 120px;
      margin: 10px auto;
      .content-user-value {
        margin-top: 10px;
        width: 40px;
        float: left;
        text-align: center;
      }
    }
  }
  .content-value {
    text-align: left;
    // width: 80%;
    .content-value-html {
      margin: 20px;
      .reply-btn {
        margin-top: 10px;
      }
    }
  }
  .el-form-item__error {
    color: #f56c6c;
    font-size: 14px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
  }
  .error {
    color: #f56c6c;
    font-size: 14px;
    margin-top: 5px;
  }
}
</style>
